import React, { useState, useEffect, useContext } from 'react';
import axios from '../../../../axios/index';
import { Form, Modal } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { ToastContainer, toast } from 'react-toastify';

// Context
import { UserContext } from '../../../Context/UserContextProvider';

// styles
import styles from "./AddBlog.module.css"
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";
import 'react-toastify/dist/ReactToastify.css';

//Images
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg"

const SubmebuDropdown = (props) => {
    const { userToken } = useContext(UserContext);
    const [subParentItems, setSubParentItems] = useState([])

    const [isShowModal, setIsShowModal] = useState(false);
    const [updated, setUpdated] = useState(false);

    const [category, setCategory] = useState({
        title: "",
        slug: ""
    });

    const onAddCategory = () => {
        setIsShowModal(true);
        setCategory("");
    }

    useEffect(() => {
        const getData = async () => {
            // console.log(props?.id)
            if (updated) {
                const getApiData = await axios.get(
                    `ArticleCategory/getChild/${props?.id}`,
                    {
                        headers: { authorization: "Bearer " + props.userToken },
                    }
                );
                setSubParentItems(getApiData.data.data)
            }
            const getApiData = await axios.get(
                `ArticleCategory/getChild/${props?.id}`,
                {
                    headers: { authorization: "Bearer " + props.userToken },
                }
            );
            setSubParentItems(getApiData.data.data)
        }
        getData()
    }, [props.id, props.userToken, updated])

    return (
        <>

            <ToastContainer
                position="top-right"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <style type="text/css">
                {`
    .dropdown-toggle {
        width: 295px;
        height: 48px;
        background: #f9f9f9;
        border: 1px solid #e2e2e2;
        border-radius: 34px;
        margin-left: 0.75rem;
        color: #1D1D1D;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .dropdown-toggle:after,
    .btn-success:after {
        content: none;
    }
    
    .btn-success {
        background: #f9f9f9 !important;
        border: 1px solid #E1E1E1 !important;
        color: #8D8D8D !important;
        box-shadow: none !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
    }

    .dropdown-menu {
        width: 295px;
        height: 190px !important;
        overflow-y: scroll;
        background: #F9F9F9;
        border: 1px solid #E1E1E1;
        border-radius: 34px;
    }

   .dropdown-menu::-webkit-scrollbar{
    width: 4px;
    height: 60px;
    }
    
    .dropdown-menu::-webkit-scrollbar-track {
        background: transparent;
        margin-block: 10px;
    }

    .dropdown-menu::-webkit-scrollbar-thumb {
        background: #B4B4B4;
        border-radius: 20px;
    }

    .dropdown-item {
        margin: .5rem 0;
        padding: .5rem .5rem .5rem 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #363636;
    }

    .dropdown-item:hover {
        background: transparent !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #21409A;
    }
    `}
            </style>

            <Modal
                show={isShowModal}
                onHide={() => setIsShowModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            افزودن زیرمجموعه دسته بندی
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4" dir='rtl'>
                    <div className='mt-0 mb-5'>
                        <h3 className={`fs-6 text-right`}>زیرمجموعه دسته بندی</h3>
                        <Form.Control className={styles.input} type="text" name='title' value={category.title} onChange={changeHandler} />
                    </div>
                    <div className='mt-4 mb-2'>
                        <h3 className={`fs-6 text-right`}>زیرمجموعه دسته بندی(انگلیسی)</h3>
                        <Form.Control className={styles.input} type="text" name='slug' value={category.slug} onChange={changeHandler} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 d-flex align-items-center justify-content-center ms-4">
                        <button className={ModalStyles.map_btn} onClick={postCategoryHandler}>ثبت</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <div className="py-2 me-0">
                <div
                    className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 mx-0"
                    dir="rtl"
                >
                    <div className="d-flex align-items-start justify-content-center flex-column">
                        <div className={`mb-2 ${styles.title_text_gray}`}>
                            زیرمجموعه دسته بندی
                        </div>
                        <Dropdown dir='rtl'>
                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                {props.selectedSubParent ? props.selectedSubParent.name : "انتخاب زیرمجموعه دسته بندی"}
                                <img className='me-3' src={arrowDown} alt="icon" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {subParentItems.map((item) => (
                                    <Dropdown.Item id="subParent" key={item.id} name={item.categoryTitle} onClick={() => titleHandler(item.categoryTitle, item.id)}>
                                        {item.categoryTitle}
                                    </Dropdown.Item>
                                ))}
                                {props.id &&
                                    <Dropdown.Item className="d-flex justify-content-center w-100" id="parent">
                                        <div className={`d-flex align-items-center justify-content-center ${styles.add_category_btn}`} onClick={onAddCategory}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#21409a" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                            </svg>
                                            افزودن زیرمجموعه دسته بندی
                                        </div>
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </>
    );

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    function titleHandler(name, id,) {
        props.setSelectedSubParent({ name: name, id: id })
    }

    function changeHandler(event) {
        if (event.target.name === "slug") {
            let value = event.target.value;
            value = value.replace(/[^A-Za-z-0-9]/gi, " ");
            setCategory((prev) => {
                return { ...prev, slug: value };
            });
        } else {
            setCategory((prev) => {
                return { ...prev, [event.target.name]: event.target.value };
            });
        }
    };

    async function postCategoryHandler() {
        try {
            notify("درحال افزودن عنوان جدید", "success")
            var data = new FormData();
            data.append('CategoryTitle', category.title);
            data.append('Slug', category.slug);
            data.append('SeoData.MetaTitle', category.slug);
            data.append('SeoData.MetaDescription', category.slug);
            data.append('SeoData.MetaKeyWords', category.slug);
            data.append('SeoData.IndexPage', true);
            data.append('SeoData.Canonical', category.slug);
            data.append('SeoData.Schema', category.slug);
            data.append('ParentId', props.id);
            const apiData = await axios.post(
                "ArticleCategory",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(apiData)
            notify("عنوان جدید افزوده شد", "success")
            setUpdated(true)
            setIsShowModal(false)
        } catch (error) {
            notify("خطای سرور", "error")
            setIsShowModal(false)
        }
    }
};

export default SubmebuDropdown;